/*******************************************************
 * MAP UTILS SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


	.factory("MapUtils", function () {

		return {
			getCrossingPointsCoordinates: getCrossingPointsCoordinates,
			getDistanceFromLatLonInKm: getDistanceFromLatLonInKm,
			getFormatedMetricDistance: getFormatedMetricDistance

		};

		////////////////////////////////////////////////////////////////////////////////////////////
		//intersection and geometry conversion functions// SOURCE : http://jsfiddle.net/nathansnider/egzxw86h/
		////////////////////////////////////////////////////////////////////////////////////////////

		// corrected intersection code from https://github.com/maxogden/geojson-js-utils
		// (using projected coordinates, because straight lat/lons will produce incorrect results)
		// originally adapted from http://www.kevlindev.com/gui/math/intersection/Intersection.js
		function lineStringsIntersect(drawnLines, baseLines) {
			var intersects = [];
			for (var i = 0; i <= drawnLines.coordinates.length - 2; ++i) {
				for (var j = 0; j <= baseLines.coordinates.length - 2; ++j) {
					var a1Latlon = L.latLng(drawnLines.coordinates[i][1], drawnLines.coordinates[i][0]),
						a2Latlon = L.latLng(drawnLines.coordinates[i + 1][1], drawnLines.coordinates[i + 1][0]),
						b1Latlon = L.latLng(baseLines.coordinates[j][1], baseLines.coordinates[j][0]),
						b2Latlon = L.latLng(baseLines.coordinates[j + 1][1], baseLines.coordinates[j + 1][0]),
						a1 = L.Projection.SphericalMercator.project(a1Latlon),
						a2 = L.Projection.SphericalMercator.project(a2Latlon),
						b1 = L.Projection.SphericalMercator.project(b1Latlon),
						b2 = L.Projection.SphericalMercator.project(b2Latlon),
						ua_t = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
						ub_t = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
						u_b = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
					if (u_b !== 0) {
						var ua = ua_t / u_b,
							ub = ub_t / u_b;
						if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
							var pt_x = a1.x + ua * (a2.x - a1.x),
								pt_y = a1.y + ua * (a2.y - a1.y),
								pt_xy = {
									"x": pt_x,
									"y": pt_y
								},
								pt_latlon = L.Projection.SphericalMercator.unproject(pt_xy);
							intersects.push({
								baseLine: {
									start: b1Latlon,
									end: b2Latlon
								},
								drawnLine: {
									start: a1Latlon,
									end: a2Latlon
								},
								"type": "Point",
								"coordinates": [pt_latlon.lng, pt_latlon.lat]
							});
						}
					}
				}
			}
			if (intersects.length === 0) intersects = false;
			return intersects;
		}

		//takes GeoJSON as input, creates a GeoJSON GeometryCollection of linestrings as output
		function lineify(inputGeom) {
			var outputLines = {
				"type": "GeometryCollection",
				"geometries": []
			};

			var geomLines;

			switch (inputGeom.type) {
			case "GeometryCollection":
				for (var i in inputGeom.geometries) {
					geomLines = lineify(inputGeom.geometries[i]);
					if (geomLines) {
						for (var j in geomLines.geometries) {
							outputLines.geometries.push(geomLines.geometries[j]);
						}
					} else {
						outputLines = false;
					}
				}
				break;
			case "Feature":
				geomLines = lineify(inputGeom.geometry);
				if (geomLines) {
					for (var j in geomLines.geometries) {
						outputLines.geometries.push(geomLines.geometries[j]);
					}
				} else {
					outputLines = false;
				}
				break;
			case "FeatureCollection":
				for (var i in inputGeom.features) {
					geomLines = lineify(inputGeom.features[i].geometry);
					if (geomLines) {
						for (var j in geomLines.geometries) {
							outputLines.geometries.push(geomLines.geometries[j]);
						}
					} else {
						outputLines = false;
					}
				}
				break;
			case "LineString":
				outputLines.geometries.push(inputGeom);
				break;
			case "MultiLineString":
			case "Polygon":
				for (var i in inputGeom.coordinates) {
					outputLines.geometries.push({
						"type": "LineString",
						"coordinates": inputGeom.coordinates[i]
					});
				}
				break;
			case "MultiPolygon":
				for (var i in inputGeom.coordinates) {
					for (var j in inputGeom.coordinates[i]) {
						outputLines.geometries.push({
							"type": "LineString",
							"coordinates": inputGeom.coordinates[i][j]
						});
					}
				}
				break;
			default:
				outputLines = false;
			}
			return outputLines;
		}

		//takes Leaflet layers as input; produces geoJSON points of their intersections as output
		function getCrossingPointsCoordinates(baseLayer, drawLayer) {
			var baseJson = baseLayer.toGeoJSON(),
				drawJson = drawLayer.toGeoJSON(),
				baseLines = lineify(baseJson),
				drawLines = lineify(drawJson),
				crossPoints = [];
			if (baseLines && drawLines) {
				for (var i in drawLines.geometries) {
					for (var j in baseLines.geometries) {
						var crossTest = lineStringsIntersect(drawLines.geometries[i], baseLines.geometries[j]);
						if (crossTest) {
							for (var k in crossTest) {
								crossPoints.push(crossTest[k]);
							}
						}
					}
				}
			}
			return crossPoints;
		}

		/**
		 * Calcule la distance entre 2 points a vol d'oiseau en prenant en compte la circonférence de la terre (Haversine formula)
		 * @param lat1
		 * @param lon1
		 * @param lat2
		 * @param lon2
		 * @returns {number}
		 */
		function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
			const R = 6371; // Radius of the earth in km
			const dLat = deg2rad(lat2-lat1);  // deg2rad below
			const dLon = deg2rad(lon2-lon1);
			const a =
				Math.sin(dLat/2) * Math.sin(dLat/2) +
				Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
				Math.sin(dLon/2) * Math.sin(dLon/2)
			;
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
			const d = R * c; // Distance in km
			return d;
		}

		function deg2rad(deg) {
			return deg * (Math.PI/180)
		}

		/**
		 * Formatte les metres retournés par la fonction de calcul haversienne sur la base de x ou 0.x kms
		 * En KiloMétres ou metres selon la valeur
		 * @param dist
		 * @returns {string}
		 */
		function getFormatedMetricDistanceFromKms(distKms) {
			let formated = Math.floor(distKms * 10) / 10;
			let label = formated < parseFloat(1) ? formated + ' m' : formated + ' km';
			return label;
		}

		/**
		 * Formatte les metres retournés par le calcul OSRM sur la base de x ou 0.x mts
		 * En metres KiloMétres ou metres selon la valeur
		 * @param dist
		 * @param isKmsOrMtsDecisiveBool
		 * @returns {string}
		 */
		function getFormatedMetricDistance(dist, isKmsOrMtsDecisiveBool) {
			let isMetersDisplay;
			let valueMeters, valueKm;

			//From Kilometers case calculation
			if(isKmsOrMtsDecisiveBool) {
				valueMeters = Math.floor(dist * 10) / 10;
				valueKm = valueMeters;
				isMetersDisplay = valueMeters < 1;
			} else {
				//From Meters case calculation
				valueMeters = Math.floor(dist);
				valueKm = Math.floor((valueMeters / 1000) * 10) / 10;
				isMetersDisplay = valueMeters < 1000;
			}

			return isMetersDisplay ? `${valueMeters} m` : `${valueKm} km`;
		}

	})
;
